module.exports = __webpack_public_path__ + "assets/img/14_931_big.6296721f.jpg";